<template>
  <div>
    <table-actions>
      <button @click="syncDealers">Синхронизировать</button>
      <router-link to="/dealers/new" tag="button">Создать</router-link>
    </table-actions>
    <table-element v-bind="tableOpt" v-on:changeOrder="changeOrder" v-on:rowClick="rowClick">
      <template #city="{ value }">{{ value.title }}</template>
      <template #status="{ value }">{{ value.title }}</template>
      <template #phones="{ value }">{{ value ? value.join(',') : '' }}</template>
      <template #address="{ value }">{{ value ? value.join(',') : '' }}</template>
    </table-element>

    <paginator :model="meta.list_data" @change="changePage" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TableElement from '@/components/common/TableElement';
import TableActions from '@/components/common/TableActions';

export default {
  name: 'all-dealers-table',

  components: {
    TableElement,
    TableActions,
  },

  props: {
    tableOptions: Object,
  },

  computed: {
    ...mapGetters({
      meta: 'dealers/meta',
    }),

    tableOpt() {
      return {
        ...this.tableOptions,

        columns: [
          { label: 'Название', name: 'title', width: '20%' },
          { label: 'Город', name: 'city' },
          { label: 'Адрес', name: 'address', width: '20%' },
          { label: 'Еmail', name: 'email' },
          { label: 'Телефон', name: 'phones' },
          { label: 'Статус', name: 'status' },
        ],
      };
    },
  },

  methods: {
    ...mapActions({
      sync: 'dealers/sync',
    }),

    async syncDealers() {
      const err = await this.sync();
      if (!err) {
        this.$snotify.success('Запрос на синхронизацию принят.', null, {
          showProgressBar: false,
        });
      } else {
        this.$snotify.error('Ошибка при запросе на синхронизацию.', null, {
          showProgressBar: false,
        });
      }
    },

    changeOrder(column) {
      this.$emit('changeOrder', column);
    },

    changePage(skip) {
      this.$emit('changePage', skip);
    },

    rowClick(id) {
      this.$emit('rowClick', id);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
